import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const FAVORITE_CANDIDATES_ITEMS_PER_PAGE = 5;

export const useGetFavoriteCandidates = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getFavoriteCandidates = (
    page: number = 1,
    limit: number = FAVORITE_CANDIDATES_ITEMS_PER_PAGE
  ) => {
    send({}, `/api/v1/favourites?limit=${limit}&page=${page}`).then();
  };

  return {
    getFavoriteCandidates,
    data,
    isLoading,
    error,
  };
};
